type CycleLengthRange = {
  minAverageCycleLength: number;
  maxAverageCycleLength: number;
};

function parseIsoDate(value: string | null | undefined): number | null {
  if (!value) return null;

  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (!match) return null;

  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const timestamp = Date.UTC(year, month - 1, day);
  const date = new Date(timestamp);

  if (
    date.getUTCFullYear() !== year ||
    date.getUTCMonth() !== month - 1 ||
    date.getUTCDate() !== day
  ) {
    return null;
  }

  return timestamp;
}

/** Derive the observed cycle-length range from period start dates. */
export function deriveCycleLengthRange(
  startDates: (string | null | undefined)[],
): CycleLengthRange | null {
  const timestamps = startDates
    .map(parseIsoDate)
    .filter((timestamp): timestamp is number => timestamp !== null)
    .sort((a, b) => a - b);

  if (timestamps.length < 2) return null;

  const lengths = timestamps
    .slice(1)
    .map((timestamp, index) =>
      Math.round((timestamp - timestamps[index]!) / (24 * 60 * 60 * 1000)),
    )
    .filter((length) => length > 0);

  if (lengths.length === 0) return null;

  return {
    minAverageCycleLength: Math.min(...lengths),
    maxAverageCycleLength: Math.max(...lengths),
  };
}
